var m = Object.defineProperty;
var u = (s, t, e) => t in s ? m(s, t, { enumerable: !0, configurable: !0, writable: !0, value: e }) : s[t] = e;
var r = (s, t, e) => (u(s, typeof t != "symbol" ? t + "" : t, e), e);
import { Mesh as a } from "three";
import { createGeometry as o } from "../create-geometry/index2.js";
class d extends a {
  constructor(e, i, h) {
    const g = o(e);
    super(g, i);
    r(this, "isRgMesh", !0);
    r(this, "rgUuid");
    r(this, "view");
    this.view = h, this.rgUuid = e.uuid, this.name = e.name;
  }
  updateGeo() {
    const e = o(this.parent.userData);
    this.geometry.copy(e), e.dispose();
  }
}
const M = (s) => s.mesh;
export {
  d as RgMesh,
  M as getRgMesh
};
//# sourceMappingURL=index3.js.map
